import { render, staticRenderFns } from "./chargeGroup.vue?vue&type=template&id=66ef1114&"
import script from "./chargeGroup.vue?vue&type=script&lang=js&"
export * from "./chargeGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ef1114')) {
      api.createRecord('66ef1114', component.options)
    } else {
      api.reload('66ef1114', component.options)
    }
    module.hot.accept("./chargeGroup.vue?vue&type=template&id=66ef1114&", function () {
      api.rerender('66ef1114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/chargeGroup.vue"
export default component.exports